import { Div, Icon, Touchable } from "@grassrootly/rn-core";
import GamePlayer from "./GamePlayer";
import { GamePlayersProps } from "./GameAttendees.types";
import { useUser } from "../../../api/auth/AuthSelector";

export default function GamePlayers({ attendees, showTeam, onSelected, selectedId, showPoints, hostTeamName, hostTeamLogo, visitorTeamName, visitorTeamLogo, navigation }: GamePlayersProps) {
  const user = useUser();
  let atts = [...attendees];
  // When voting (onSelected provided), omit the logged-in player from the list so they cannot vote for themselves
  if (onSelected && user?.id) {
    atts = atts.filter((a) => a.player_id !== user.id);
  }
  
  // Create callback for player profile navigation
  const handlePlayerPress = navigation ? (playerId: number) => {
    navigation.navigate("eqipa-card", { playerId });
  } : undefined;
  
  return (
    <Div classNames={["flex1"]}>
      {atts
        .filter((a) => a.attended)
        .sort((a, b) => {
          // Sort goalkeepers first
          if (a.position === 'GK' && b.position !== 'GK') return -1;
          if (a.position !== 'GK' && b.position === 'GK') return 1;
          // Then sort by rating
          return b.rating - a.rating;
        })
        .map((attendee, index) => {
          const onRowPress = onSelected ? () => onSelected(attendee.id) : undefined;
          
          return (
            <Touchable
              onPress={onRowPress}
              disabled={!onSelected}
              key={index}
              classNames={["p16", index % 2 !== 0 ? "bgSecondaryMain" : "", "flexRow", "alignItemsCenter"]}
            >
              {onSelected ? (
                <Div
                  classNames={[
                    "h-{15}",
                    "w-{15}",
                    "br-{15}",
                    "borderPrimary",
                    "bw-{1}",
                    "mr-{16}",
                    "alignItemsCenter",
                    "justifyContentCenter",
                    selectedId === attendee.id ? "bgPrimaryMain" : "",
                  ]}
                >
                  {selectedId === attendee.id ? (
                    <Icon classNames={["colorNeutralLighterLight"]} size={12} name="check" />
                  ) : null}
                </Div>
              ) : null}
              <GamePlayer 
                attendee={attendee} 
                showTeam={showTeam} 
                showPoints={showPoints}
                hostTeamName={hostTeamName}
                hostTeamLogo={hostTeamLogo}
                visitorTeamName={visitorTeamName}
                visitorTeamLogo={visitorTeamLogo}
                onPlayerPress={handlePlayerPress}
              />
            </Touchable>
          );
        })}
    </Div>
  );
}
